module.exports = new __parcel__URL__("version-detail-skeleton.tpl.c4c4fc18.svg").toString();